import { withState } from 'recompose';

export default withState('placeList', 'setPlaceList', {
  initial: [],
  current: []
});
